import { render, staticRenderFns } from "./MyModals.vue?vue&type=template&id=0c07fd1f&scoped=true&"
import script from "./MyModals.vue?vue&type=script&lang=js&"
export * from "./MyModals.vue?vue&type=script&lang=js&"
import style0 from "./MyModals.vue?vue&type=style&index=0&id=0c07fd1f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c07fd1f",
  null
  
)

export default component.exports